/**
 * @file Generated by js-routes 2.4.0. Based on Rails 8.1.3 routes of MinerPlatform::Application.
 * @version 5b418d2bd75f69f8df5a2e472e92eaf7a4d5b93098adfdc7af9e1810ab054656
 * @see https://github.com/railsware/js-routes
 */
// eslint-disable-next-line @typescript-eslint/no-unused-expressions
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Router = (() => {
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class Router {
        constructor(config = {}) {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "__options__",
                serializer: this.default_serializer.bind(this),
                deprecated_false_parameter_behavior: false,
                deprecated_nil_query_parameter_behavior: false,
                include_undefined_query_parameters: true,
            };
            this.configure(config);
        }
        configure(new_config) {
            var _a;
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            (_a = new_config.serializer) !== null && _a !== void 0 ? _a : (new_config.serializer = this.default_serializer.bind(this));
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        __route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        default_serializer(value, prefix, array_element = false) {
            if (!prefix && !this.is_object(value)) {
                throw new Error("URL parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                // Rails serializes an empty array nested inside another array as a nil
                // query value, while an empty object contributes no query parameter.
                if (value.length === 0) {
                    return array_element
                        ? this.default_serializer(null, prefix + "[]")
                        : "";
                }
                for (const element of value) {
                    const subvalue = this.default_serializer(element, prefix + "[]", true);
                    // Skip empty object results so arrays do not produce leading,
                    // trailing, or doubled "&" separators.
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!this.hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (!this.configuration.include_undefined_query_parameters &&
                        prop === undefined) {
                        continue;
                    }
                    if (prefix) {
                        key = prefix + "[" + key + "]";
                    }
                    const subvalue = this.default_serializer(prop, key);
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else {
                const key = encodeURIComponent(prefix);
                result.push(this.is_not_nullable(value) ||
                    this.configuration.deprecated_nil_query_parameter_behavior
                    ? key + "=" + encodeURIComponent("" + (value !== null && value !== void 0 ? value : ""))
                    : key);
            }
            return result.join("&");
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) && !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (this.configuration.deprecated_false_parameter_behavior &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!this.hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!this.hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!this.hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !this.hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        hasProp(value, key) {
            return Object.prototype.hasOwnProperty.call(value, key);
        }
    }
    return Router;
})();
;
const __jsr = (() => {
    var _a;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    ;
    const Modules = {
        references: {
            CJS: {
                define(routes) {
                    if (module) {
                        // Some javascript processors (like vite/rolldown)
                        // warn on using module dot exports in an ESM module.
                        // This just obfuscates that assignment a little so
                        // users don't get a warning they can't fix.
                        const _mod = module;
                        _mod.exports = routes;
                    }
                },
                isSupported() {
                    return typeof module === "object";
                },
            },
            AMD: {
                define(routes) {
                    if (define) {
                        define([], function () {
                            return routes;
                        });
                    }
                },
                isSupported() {
                    return typeof define === "function" && !!define.amd;
                },
            },
            UMD: {
                define(routes) {
                    if (Modules.references.AMD.isSupported()) {
                        Modules.references.AMD.define(routes);
                    }
                    else {
                        if (Modules.references.CJS.isSupported()) {
                            try {
                                Modules.references.CJS.define(routes);
                            }
                            catch (error) {
                                if (error.name !== "TypeError")
                                    throw error;
                            }
                        }
                    }
                },
                isSupported() {
                    return (Modules.references.AMD.isSupported() ||
                        Modules.references.CJS.isSupported());
                },
            },
            ESM: {
                define() {
                    // Module can only be defined using ruby code generation
                },
                isSupported() {
                    // Its impossible to check if "export" keyword is supported
                    return true;
                },
            },
            NIL: {
                define() {
                    // Defined using RubyVariables . WRAPPER
                },
                isSupported() {
                    return true;
                },
            },
            DTS: {
                // Acts the same as ESM
                define(routes) {
                    Modules.references.ESM.define(routes);
                },
                isSupported() {
                    return Modules.references.ESM.isSupported();
                },
            },
            PKG: {
                // Acts the same as ESM
                define() {
                    Modules.references.ESM.define(new Router());
                },
                isSupported() {
                    return Modules.references.ESM.isSupported();
                },
            },
        },
        is_module_supported(name) {
            return this.references[name].isSupported();
        },
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        },
        define_module(name, module) {
            this.ensure_module_supported(name);
            this.references[name].define(module);
            return module;
        },
    };
    const router = new Router({
        prefix: "",
        default_url_options: {},
        special_options_key: "_options",
        serializer: (_a = null) !== null && _a !== void 0 ? _a : undefined,
        deprecated_false_parameter_behavior: false,
        deprecated_nil_query_parameter_behavior: false,
        include_undefined_query_parameters: true,
    });
    const __route = router.__route.bind(router);
    return Modules.define_module("ESM", {
        __route,
        configure: router.configure.bind(router),
        config: router.config.bind(router),
        serialize: router.serialize.bind(router),
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

export const __route = __jsr.__route;

/**
 * Generates rails route to
 * /~/:organization_slug/:account_id/pillar_insights/:pillar_insight_id/improvement_levers/:id/actions(.:format)
 * @param {any} organization_slug
 * @param {any} account_id
 * @param {any} pillar_insight_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const actions_bizminer_app_pillar_insight_improvement_lever_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"account_id":{"r":true},"pillar_insight_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"pillar_insights"],[2,[7,"/"],[2,[3,"pillar_insight_id"],[2,[7,"/"],[2,[6,"improvement_levers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"actions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:organization_id/users/:id/approve(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approve_bizminer_admin_organization_user_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:organization_id/accounts/:account_id/pillar_insights/:id/attach_docx(.:format)
 * @param {any} organization_id
 * @param {any} account_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const attach_docx_bizminer_admin_organization_account_pillar_insight_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"pillar_insights"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"attach_docx"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/industries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_admin_industries_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"industries"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/industries/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_admin_industry_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"industries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/insight_requests/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_admin_insight_request_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"insight_requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/insight_requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_admin_insight_requests_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"insight_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/kpi_model_nodes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_admin_kpi_model_node_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"kpi_model_nodes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/kpi_model_nodes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_admin_kpi_model_nodes_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"kpi_model_nodes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_admin_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:organization_id/accounts/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_admin_organization_account_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:organization_id/accounts/:account_id/pillar_insights/:id(.:format)
 * @param {any} organization_id
 * @param {any} account_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_admin_organization_account_pillar_insight_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"pillar_insights"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:organization_id/accounts(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_admin_organization_accounts_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:organization_id/credits(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_admin_organization_credits_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"credits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:organization_id/sso_config(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_admin_organization_sso_config_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"sso_config"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:organization_id/subscription_plan(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_admin_organization_subscription_plan_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"subscription_plan"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:organization_id/users/:id(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_admin_organization_user_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:organization_id/users(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_admin_organization_users_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_admin_organizations_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_admin_root_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/session(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_admin_session_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"session"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/yaml-validation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_admin_yaml_validation_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"yaml-validation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/yaml-validation/example(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_admin_yaml_validation_example_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"yaml-validation"],[2,[7,"/"],[2,[6,"example"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/:account_id/account(.:format)
 * @param {any} organization_slug
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_app_account_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/:account_id(.:format)
 * @param {any} organization_slug
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_app_account_root_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[3,"account_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/accounts(.:format)
 * @param {any} organization_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_app_accounts_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/contacts(.:format)
 * @param {any} organization_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_app_contacts_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/credits(.:format)
 * @param {any} organization_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_app_credits_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"credits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/faq(.:format)
 * @param {any} organization_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_app_faq_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"faq"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/password_resets/:token(.:format)
 * @param {any} organization_slug
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_app_password_reset_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"password_resets"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/password_resets(.:format)
 * @param {any} organization_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_app_password_resets_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"password_resets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/:account_id/pillar_insights/:id(.:format)
 * @param {any} organization_slug
 * @param {any} account_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_app_pillar_insight_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"pillar_insights"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/:account_id/pillar_insights/:pillar_insight_id/functional_insights/:category_id(.:format)
 * @param {any} organization_slug
 * @param {any} account_id
 * @param {any} pillar_insight_id
 * @param {any} category_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_app_pillar_insight_functional_insight_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"account_id":{"r":true},"pillar_insight_id":{"r":true},"category_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"pillar_insights"],[2,[7,"/"],[2,[3,"pillar_insight_id"],[2,[7,"/"],[2,[6,"functional_insights"],[2,[7,"/"],[2,[3,"category_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/:account_id/pillar_insights/:pillar_insight_id/functional_insights(.:format)
 * @param {any} organization_slug
 * @param {any} account_id
 * @param {any} pillar_insight_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_app_pillar_insight_functional_insights_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"account_id":{"r":true},"pillar_insight_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"pillar_insights"],[2,[7,"/"],[2,[3,"pillar_insight_id"],[2,[7,"/"],[2,[6,"functional_insights"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/:account_id/pillar_insights/:pillar_insight_id/improvement_levers/:id(.:format)
 * @param {any} organization_slug
 * @param {any} account_id
 * @param {any} pillar_insight_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_app_pillar_insight_improvement_lever_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"account_id":{"r":true},"pillar_insight_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"pillar_insights"],[2,[7,"/"],[2,[3,"pillar_insight_id"],[2,[7,"/"],[2,[6,"improvement_levers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/:account_id/pillar_insights/:pillar_insight_id/improvement_levers(.:format)
 * @param {any} organization_slug
 * @param {any} account_id
 * @param {any} pillar_insight_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_app_pillar_insight_improvement_levers_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"account_id":{"r":true},"pillar_insight_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"pillar_insights"],[2,[7,"/"],[2,[3,"pillar_insight_id"],[2,[7,"/"],[2,[6,"improvement_levers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/:account_id/pillar_insights/:pillar_insight_id/insight_request(.:format)
 * @param {any} organization_slug
 * @param {any} account_id
 * @param {any} pillar_insight_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_app_pillar_insight_insight_request_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"account_id":{"r":true},"pillar_insight_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"pillar_insights"],[2,[7,"/"],[2,[3,"pillar_insight_id"],[2,[7,"/"],[2,[6,"insight_request"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/:account_id/pillar_insights/:pillar_insight_id/scoring_categories/:category_id(.:format)
 * @param {any} organization_slug
 * @param {any} account_id
 * @param {any} pillar_insight_id
 * @param {any} category_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_app_pillar_insight_scoring_category_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"account_id":{"r":true},"pillar_insight_id":{"r":true},"category_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"pillar_insights"],[2,[7,"/"],[2,[3,"pillar_insight_id"],[2,[7,"/"],[2,[6,"scoring_categories"],[2,[7,"/"],[2,[3,"category_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/:account_id/pillar_insights/:pillar_insight_id/swot(.:format)
 * @param {any} organization_slug
 * @param {any} account_id
 * @param {any} pillar_insight_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_app_pillar_insight_swot_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"account_id":{"r":true},"pillar_insight_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"pillar_insights"],[2,[7,"/"],[2,[3,"pillar_insight_id"],[2,[7,"/"],[2,[6,"swot"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/product_guides/:id(.:format)
 * @param {any} organization_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_app_product_guide_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"product_guides"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/product_guides(.:format)
 * @param {any} organization_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_app_product_guides_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"product_guides"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/related_initiatives(.:format)
 * @param {any} organization_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_app_related_initiatives_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"related_initiatives"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/reports(.:format)
 * @param {any} organization_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_app_reports_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/reports/export_heatmap_pptx(.:format)
 * @param {any} organization_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_app_reports_export_heatmap_pptx_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"export_heatmap_pptx"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug(.:format)
 * @param {any} organization_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_app_root_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/session(.:format)
 * @param {any} organization_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_app_session_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"session"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /magic/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_magic_login_path = /*#__PURE__*/ __route({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"magic"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /auth/:provider/callback(.:format)
 * @param {any} provider
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_omniauth_callback_path = /*#__PURE__*/ __route({"provider":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[3,"provider"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/failure(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_omniauth_failure_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"failure"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_public_root_path = /*#__PURE__*/ __route({}, [7,"/"]);

/**
 * Generates rails route to
 * /webhooks/analysis_engine(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bizminer_webhooks_analysis_engine_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[6,"analysis_engine"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:organization_id/users/bulk_create(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_create_bizminer_admin_organization_users_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"bulk_create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:organization_id/users/bulk_destroy(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulk_destroy_bizminer_admin_organization_users_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"bulk_destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/insight_requests/:id/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_bizminer_admin_insight_request_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"insight_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/kpi_model_nodes/:id/children(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const children_bizminer_admin_kpi_model_node_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"kpi_model_nodes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"children"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/accounts/:id/competitive(.:format)
 * @param {any} organization_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const competitive_salesminer_app_account_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"competitive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/:account_id/pillar_insights/:pillar_insight_id/swot/:competitor(.:format)
 * @param {any} organization_slug
 * @param {any} account_id
 * @param {any} pillar_insight_id
 * @param {any} competitor
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const competitor_bizminer_app_pillar_insight_swot_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"account_id":{"r":true},"pillar_insight_id":{"r":true},"competitor":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"pillar_insights"],[2,[7,"/"],[2,[3,"pillar_insight_id"],[2,[7,"/"],[2,[6,"swot"],[2,[7,"/"],[2,[3,"competitor"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/:account_id/pillar_insights/:pillar_insight_id/functional_insights/:category_id/deep_dive(.:format)
 * @param {any} organization_slug
 * @param {any} account_id
 * @param {any} pillar_insight_id
 * @param {any} category_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deep_dive_bizminer_app_pillar_insight_functional_insight_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"account_id":{"r":true},"pillar_insight_id":{"r":true},"category_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"pillar_insights"],[2,[7,"/"],[2,[3,"pillar_insight_id"],[2,[7,"/"],[2,[6,"functional_insights"],[2,[7,"/"],[2,[3,"category_id"],[2,[7,"/"],[2,[6,"deep_dive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/:account_id/pillar_insights/:pillar_insight_id/improvement_levers/:id/deep_dive(.:format)
 * @param {any} organization_slug
 * @param {any} account_id
 * @param {any} pillar_insight_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deep_dive_bizminer_app_pillar_insight_improvement_lever_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"account_id":{"r":true},"pillar_insight_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"pillar_insights"],[2,[7,"/"],[2,[3,"pillar_insight_id"],[2,[7,"/"],[2,[6,"improvement_levers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"deep_dive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/accounts/:id/details(.:format)
 * @param {any} organization_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const details_salesminer_app_account_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organization_uploads/:id/download_file(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_file_salesminer_admin_organization_upload_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organization_uploads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organization_uploads/download_template(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_template_salesminer_admin_organization_uploads_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organization_uploads"],[2,[7,"/"],[2,[6,"download_template"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_bizminer_admin_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/session/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_bizminer_admin_session_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"session"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/:account_id/account/edit(.:format)
 * @param {any} organization_slug
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_bizminer_app_account_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"account"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/password_resets/:token/edit(.:format)
 * @param {any} organization_slug
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_bizminer_app_password_reset_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"password_resets"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/session/edit(.:format)
 * @param {any} organization_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_bizminer_app_session_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"session"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_salesminer_admin_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organization_uploads/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_salesminer_admin_organization_upload_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organization_uploads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/session/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_salesminer_admin_session_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"session"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/session/edit(.:format)
 * @param {any} organization_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_salesminer_app_session_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"session"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/kpi_model_nodes/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_bizminer_admin_kpi_model_nodes_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"kpi_model_nodes"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:organization_id/users/:id/generate_magic_link(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_magic_link_bizminer_admin_organization_user_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"generate_magic_link"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/:account_id/pillar_insights/:pillar_insight_id/functional_insights/:category_id/kpi_drivers(.:format)
 * @param {any} organization_slug
 * @param {any} account_id
 * @param {any} pillar_insight_id
 * @param {any} category_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const kpi_drivers_bizminer_app_pillar_insight_functional_insight_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"account_id":{"r":true},"pillar_insight_id":{"r":true},"category_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"pillar_insights"],[2,[7,"/"],[2,[3,"pillar_insight_id"],[2,[7,"/"],[2,[6,"functional_insights"],[2,[7,"/"],[2,[3,"category_id"],[2,[7,"/"],[2,[6,"kpi_drivers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_path = /*#__PURE__*/ __route({}, [2,[7,"/"],[6,"jobs"]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/jobs/bulk_discards(.:format)
 * @param {any} application_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_bulk_discards_path = /*#__PURE__*/ __route({"application_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"bulk_discards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/jobs/bulk_retries(.:format)
 * @param {any} application_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_bulk_retries_path = /*#__PURE__*/ __route({"application_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"bulk_retries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/jobs/:id(.:format)
 * @param {any} application_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_job_path = /*#__PURE__*/ __route({"application_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/jobs/:job_id/discard(.:format)
 * @param {any} application_id
 * @param {any} job_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_job_discard_path = /*#__PURE__*/ __route({"application_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"discard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/jobs/:job_id/dispatch(.:format)
 * @param {any} application_id
 * @param {any} job_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_job_dispatch_path = /*#__PURE__*/ __route({"application_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"dispatch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/jobs/:job_id/retry(.:format)
 * @param {any} application_id
 * @param {any} job_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_job_retry_path = /*#__PURE__*/ __route({"application_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/:status/jobs(.:format)
 * @param {any} application_id
 * @param {any} status
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_jobs_path = /*#__PURE__*/ __route({"application_id":{"r":true},"status":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[3,"status"],[2,[7,"/"],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/queues/:id(.:format)
 * @param {any} application_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_queue_path = /*#__PURE__*/ __route({"application_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"queues"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/queues/:queue_id/pause(.:format)
 * @param {any} application_id
 * @param {any} queue_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_queue_pause_path = /*#__PURE__*/ __route({"application_id":{"r":true},"queue_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"queues"],[2,[7,"/"],[2,[3,"queue_id"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/queues(.:format)
 * @param {any} application_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_queues_path = /*#__PURE__*/ __route({"application_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"queues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/recurring_tasks/:id(.:format)
 * @param {any} application_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_recurring_task_path = /*#__PURE__*/ __route({"application_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"recurring_tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/recurring_tasks(.:format)
 * @param {any} application_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_recurring_tasks_path = /*#__PURE__*/ __route({"application_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"recurring_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/workers/:id(.:format)
 * @param {any} application_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_worker_path = /*#__PURE__*/ __route({"application_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"workers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/workers(.:format)
 * @param {any} application_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_workers_path = /*#__PURE__*/ __route({"application_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"workers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/jobs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_job_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /jobs/:status/jobs(.:format)
 * @param {any} status
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_jobs_path = /*#__PURE__*/ __route({"status":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[3,"status"],[2,[7,"/"],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /jobs/queues/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_queue_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"queues"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /jobs/queues(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_queues_path = /*#__PURE__*/ __route({"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"queues"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /jobs/
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_root_path = /*#__PURE__*/ __route({}, [2,[2,[7,"/"],[6,"jobs"]],[7,"/"]]);

/**
 * Generates rails route to
 * /admin/session/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_bizminer_admin_session_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"session"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/accounts/new(.:format)
 * @param {any} organization_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_bizminer_app_account_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/password_resets/new(.:format)
 * @param {any} organization_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_bizminer_app_password_reset_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"password_resets"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/session/new(.:format)
 * @param {any} organization_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_bizminer_app_session_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"session"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_source_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organization_uploads/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_salesminer_admin_organization_upload_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organization_uploads"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/session/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_salesminer_admin_session_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"session"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/session/new(.:format)
 * @param {any} organization_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_salesminer_app_session_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"session"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/:account_id/pillar_insights/:pillar_insight_id/functional_insights/:category_id/overview(.:format)
 * @param {any} organization_slug
 * @param {any} account_id
 * @param {any} pillar_insight_id
 * @param {any} category_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const overview_bizminer_app_pillar_insight_functional_insight_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"account_id":{"r":true},"pillar_insight_id":{"r":true},"category_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"pillar_insights"],[2,[7,"/"],[2,[3,"pillar_insight_id"],[2,[7,"/"],[2,[6,"functional_insights"],[2,[7,"/"],[2,[3,"category_id"],[2,[7,"/"],[2,[6,"overview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/:account_id/pillar_insights/:pillar_insight_id/improvement_levers/:id/overview(.:format)
 * @param {any} organization_slug
 * @param {any} account_id
 * @param {any} pillar_insight_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const overview_bizminer_app_pillar_insight_improvement_lever_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"account_id":{"r":true},"pillar_insight_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"pillar_insights"],[2,[7,"/"],[2,[3,"pillar_insight_id"],[2,[7,"/"],[2,[6,"improvement_levers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"overview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_path = /*#__PURE__*/ __route({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_proxy_path = /*#__PURE__*/ __route({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/incinerate(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_incinerate_path = /*#__PURE__*/ __route({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"incinerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_reroute_path = /*#__PURE__*/ __route({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_sources_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_emails_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_direct_uploads_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encoded_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_disk_service_path = /*#__PURE__*/ __route({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_health_check_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"up"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mailgun_inbound_emails_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_emails_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_health_check_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/postmark/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_postmark_inbound_emails_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/relay/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_relay_inbound_emails_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/sendgrid/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_sendgrid_inbound_emails_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_path = /*#__PURE__*/ __route({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_proxy_path = /*#__PURE__*/ __route({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:organization_id/credits/:id/refund(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refund_bizminer_admin_organization_credit_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"credits"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"refund"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:organization_id/accounts/:account_id/pillar_insights/:id/remove_docx(.:format)
 * @param {any} organization_id
 * @param {any} account_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_docx_bizminer_admin_organization_account_pillar_insight_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"pillar_insights"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_docx"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organization_uploads/:id/retry(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const retry_salesminer_admin_organization_upload_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organization_uploads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const salesminer_admin_organization_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organization_uploads/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const salesminer_admin_organization_upload_path = /*#__PURE__*/ __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organization_uploads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organization_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const salesminer_admin_organization_uploads_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organization_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const salesminer_admin_organizations_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const salesminer_admin_root_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/session(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const salesminer_admin_session_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"session"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/accounts/:id(.:format)
 * @param {any} organization_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const salesminer_app_account_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/accounts/:account_id/opportunities(.:format)
 * @param {any} organization_slug
 * @param {any} account_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const salesminer_app_account_opportunities_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"opportunities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/accounts/:account_id/opportunities/:id(.:format)
 * @param {any} organization_slug
 * @param {any} account_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const salesminer_app_account_opportunity_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"opportunities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/accounts(.:format)
 * @param {any} organization_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const salesminer_app_accounts_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/dashboard(.:format)
 * @param {any} organization_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const salesminer_app_dashboard_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/faq(.:format)
 * @param {any} organization_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const salesminer_app_faq_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"faq"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/intro(.:format)
 * @param {any} organization_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const salesminer_app_intro_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"intro"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/opportunities(.:format)
 * @param {any} organization_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const salesminer_app_opportunities_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"opportunities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/opportunities/:id(.:format)
 * @param {any} organization_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const salesminer_app_opportunity_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"opportunities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug(.:format)
 * @param {any} organization_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const salesminer_app_org_root_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/organization(.:format)
 * @param {any} organization_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const salesminer_app_organization_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"organization"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/session(.:format)
 * @param {any} organization_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const salesminer_app_session_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[6,"session"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /magic/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const salesminer_magic_login_path = /*#__PURE__*/ __route({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"magic"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const salesminer_public_root_path = /*#__PURE__*/ __route({}, [7,"/"]);

/**
 * Generates rails route to
 * /~/:organization_slug/:account_id/pillar_insights/:id/save_peer_selection(.:format)
 * @param {any} organization_slug
 * @param {any} account_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const save_peer_selection_bizminer_app_pillar_insight_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"pillar_insights"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"save_peer_selection"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /~/:organization_slug/:account_id/pillar_insights/:id/scoring(.:format)
 * @param {any} organization_slug
 * @param {any} account_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scoring_bizminer_app_pillar_insight_path = /*#__PURE__*/ __route({"organization_slug":{"r":true},"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"~"],[2,[7,"/"],[2,[3,"organization_slug"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"pillar_insights"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"scoring"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/industries/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_bizminer_admin_industries_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"industries"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/kpi_model_nodes/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_bizminer_admin_kpi_model_nodes_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"kpi_model_nodes"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:organization_id/users/:id/send_invitation(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_invitation_bizminer_admin_organization_user_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_invitation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /recede_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_recede_historical_location_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"recede_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /refresh_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_refresh_historical_location_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"refresh_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /resume_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_resume_historical_location_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"resume_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encoded_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_rails_disk_service_path = /*#__PURE__*/ __route({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:organization_id/users/:id/update_role(.:format)
 * @param {any} organization_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_role_bizminer_admin_organization_user_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_role"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:organization_id/accounts/:account_id/pillar_insights/:id/upload(.:format)
 * @param {any} organization_id
 * @param {any} account_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upload_bizminer_admin_organization_account_pillar_insight_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"account_id"],[2,[7,"/"],[2,[6,"pillar_insights"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"upload"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:organization_id/sso_config/verify_connection(.:format)
 * @param {any} organization_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verify_connection_bizminer_admin_organization_sso_config_path = /*#__PURE__*/ __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"sso_config"],[2,[7,"/"],[2,[6,"verify_connection"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /tools/yaml-validation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yaml_validation_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"yaml-validation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tools/yaml-validation/example(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const yaml_validation_example_path = /*#__PURE__*/ __route({"format":{}}, [2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"yaml-validation"],[2,[7,"/"],[2,[6,"example"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

